import { Translations, Language } from './translations';
import ptBR from './pt-BR';
import en from './en';
import es from './es';

export const translations: Record<Language, Translations> = {
  'pt-BR': ptBR,
  en,
  es,
};

export type { Language, Translations };
export { default as ptBR } from './pt-BR';
export { default as en } from './en';
export { default as es } from './es';
